import { useEffect, useState } from "react";
import { adminCall, setCsrf } from "@/lib/adminApi";
import { Container, PrimaryButton } from "@/components/site/Primitives";
import { Wordmark } from "@/components/site/Nav";
import { Field, FormAlert, inputClass } from "@/components/forms/Fields";
import AdminQueue from "./AdminQueue";

function Login({ onDone }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pending) return;
    setPending(true);
    const res = await adminCall("post", "/login", { email, password });
    setPending(false);
    setPassword("");
    if (!res.ok) return setError(res.message);
    setCsrf(res.data.csrf_token);
    onDone(res.data);
  };
  return (
    <form onSubmit={submit} className="mx-auto mt-16 max-w-sm space-y-5" data-testid="admin-login-form">
      <h1 className="font-display text-3xl font-light tracking-[-0.03em]">Owner sign in</h1>
      <Field id="a_email" label="Email" required>
        <input id="a_email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" className={inputClass} />
      </Field>
      <Field id="a_pw" label="Password" required>
        <input id="a_pw" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className={inputClass} />
      </Field>
      <FormAlert message={error} testId="admin-login-error" />
      <PrimaryButton type="submit" disabled={pending} data-testid="admin-login-button">{pending ? "Signing in…" : "Sign in"}</PrimaryButton>
    </form>
  );
}

export default function AdminPage() {
  const [state, setState] = useState({ view: "loading" });

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    adminCall("get", "/session").then((res) => {
      if (res.ok) { setCsrf(res.data.csrf_token); setState({ view: "ready", email: res.data.email }); }
      else if (res.status === 503) setState({ view: "setup", message: res.message });
      else setState({ view: "login" });
    });
    return () => meta.remove();
  }, []);

  const logout = async () => {
    await adminCall("post", "/logout", {});
    setCsrf("");
    setState({ view: "login" });
  };

  return (
    <div data-testid="admin-page" className="theme-dark min-h-screen bg-canvas text-fg">
      <header className="border-b border-fg/[0.06]">
        <Container className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-3"><Wordmark className="w-[132px]" /><span className="text-[13px] text-subtle">Review queue</span></div>
          {state.view === "ready" && (
            <button type="button" onClick={logout} data-testid="admin-logout" className="fa-link rounded-sm text-[13px] text-subtle hover:text-fg">Sign out</button>
          )}
        </Container>
      </header>
      <Container className="pb-24 pt-8">
        {state.view === "loading" && <p className="text-subtle">Loading…</p>}
        {state.view === "setup" && <FormAlert message={state.message} testId="admin-setup-required" />}
        {state.view === "login" && <Login onDone={(d) => setState({ view: "ready", email: d.email })} />}
        {state.view === "ready" && <AdminQueue onSignedOut={() => setState({ view: "login" })} />}
      </Container>
    </div>
  );
}
